import {Injectable} from "@angular/core";

@Injectable()
export class UrlService{

  getLocal(){
    //return 'http://192.168.100.5/turismocomercial/public/'
    return 'https://api.appvinta.com'
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/url.service.ts